import {BrowserRouter} from "react-router-dom"
import {AppRoutes} from "@/routes/AppRoutes"
import {TooltipProvider} from "@/components/ui/tooltip.tsx";

function App() {
    return (
        <TooltipProvider>
            <BrowserRouter>
                <AppRoutes/>
            </BrowserRouter>
        </TooltipProvider>
    )
}

export default App
